import React from 'react';

import { Country } from 'modules/refData/types/Countries';

interface UseKeybindingsParams {
  countries: Country[];
  selectedIndex: number;
  onClose: () => void;
  onClick: (country: Country, close: () => void) => () => void;
  onChange: React.Dispatch<React.SetStateAction<number>>;
}

const useKeybindings = ({
  onClick,
  onClose,
  onChange,
  countries,
  selectedIndex,
}: UseKeybindingsParams) => {
  const keyActions = React.useMemo(() => ({
    ArrowDown: (event: React.KeyboardEvent<HTMLInputElement>) => {
      event.preventDefault();
      onChange((prev) => Math.min(prev + 1, countries.length - 1));
    },
    ArrowUp: (event: React.KeyboardEvent<HTMLInputElement>) => {
      event.preventDefault();
      onChange((prev) => Math.max(prev - 1, 0));
    },
    Enter: (event: React.KeyboardEvent<HTMLInputElement>) => {
      event.preventDefault();
      if (countries[selectedIndex]) {
        onClick(countries[selectedIndex], onClose)();
      }
    },
  }), [countries, selectedIndex, onClick, onClose, onChange]);

  const handleKeyDown = React.useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      const action = keyActions[event.key as keyof typeof keyActions];
      if (action) {
        action(event);
      }
    },
    [keyActions]
  );

  return handleKeyDown;
};

export default useKeybindings;
